import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import MainLayOut from "./component/MainLayOut";
import { useEffect } from "react";
import Home from "./pages/Home";
import Contact from "./pages/contact/Contact";
import Gallery from "./pages/gallery/Gallery";
import Blog from "./pages/blog/Blog";
import VisionAndMission from "./pages/about/VisionAndMission";
import AboutUs from "./pages/about/AboutUs";
import DirectorMessage from "./pages/about/DirectorMessage";
import FAQ from "./pages/faq/FAQ";
import Facility from "./pages/facility/Facility";
import Activities from "./pages/activities/Activities";
import OurTeam from "./pages/about/OurTeam";
import PopApp from "./pages/popapp/PopApp";
import OurFaculty from "./pages/about/OurFaculty";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<MainLayOut />}>
            <Route index element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/mission-vision" element={<VisionAndMission />} />
            <Route path="/director-message" element={<DirectorMessage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/facility" element={<Facility />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/our-team" element={<OurTeam />} />
            <Route path="/our-faculty" element={<OurFaculty />} />
           
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
